export default __webpack_public_path__ + "static/media/address_image.ee6c2f85.svg";